import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './UnitedNations.css';
import './AboutPages.css';

import chairmanImg from '../images/chairman.png';
import viceChairmanImg from '../images/vice chairman.png';
import presidentImg from '../images/president.png';
import vpEmeritaaImg from '../images/emritha.jpeg';

import gdSinghImg from '../images/prof.dr.sir GD singh.png';
import drRomeshImg from '../images/hh prof.dr.sir.romesh.png';
import mrsCharmaineImg from '../images/msr.chamaine.png';

const DEFAULT_LEADERSHIP = [
  {
    id: 'lead-1',
    role: 'Chairman',
    name: 'His Eminence Prof. Dr. Sir Madhu Krishan',
    titleDetails: '',
    image: chairmanImg,
    bio: [
      'His Eminence Prof. Dr. Madhu Krishan is an Engineer, Scientist and Global Diplomat who is the Founder and Chairman of the Academy of Universal Global Peace- AUGP which is registered with the United Nations. AUGP is affiliated with DMPP Albania, United Nations, United Nations Global Compact & European Commission and World Peace Organization. He is also the President and Rector of United Nations University For Global Peace.',
      'Dr.Madhu is the Honorary Chairman & Goodwill Ambassador of Diplomatic Mission Peace And Prosperity – Albania; Ambassador of The Kingdom of Buyoro – Kitara (ARKBK) – Uganda; Ambassador of International Blue Cross – United Kingdom; Ambassador of World Parliament of Peace & Security.',
      'He has won several awards, such as, Bharath Excellence Award and Gold Medal 2006, Rashtriya Jewel Award and Gold Medal 2006 & the first ever Indian to get "USA President\'s Life Time Achievement Award" For 30 years of dedicated services in more than 77 countries. Earlier he received the best scientist award from USA.'
    ]
  },
  {
    id: 'lead-2',
    role: 'Vice Chairman',
    name: 'Prof. Dr. Sir Lakshman Madurasinghe',
    titleDetails: '',
    image: viceChairmanImg,
    bio: [
      'Prof. Dr Lakshman Madurasinghe is a Lawyer, Behavioural Scientist, Educationist, Strategist and Author of four books including Clinical Psychology, Buddhism & Christianity. He is an Academic Board Member of EDU Brussels accredited to European Parliament and the Chancellor of the United Nations University For Global Peace and Vice Chancellor of AUGP.',
      'He is an Ambassador at Large in United Refugee Green Council and a Consultant on socioeconomic development to Vassili Group in Cyprus, EU. He is the Chairman of the Eco-tourism Development project, Chairman infrastructural funding and Vice Chairman of Way to Comfort NGO.',
      'He is a life member of the Cambridge University Society of Cambridge University, England, and its former Treasurer in Sri Lanka: World Jurists Association, USA: International Council of Psychologists, USA and Institute of Counselling, Glasgow.'
    ]
  },
  {
    id: 'lead-3',
    role: 'President',
    name: 'Dr. Tharindu Wijenayake',
    titleDetails: 'GG, AJP GIA (London), M.B.A (London): D Dipl&SD (USA)',
    image: presidentImg,
    bio: [
      'Dr. Tharindu Wijenayake is an Entrepreneur, Gemologist, Philanthropist and a young energetic youth leader. He hails from a generation of patrons of social services done with their own will & funds for the Sri Lankan society. Heading the WCM youth ministry and media he is a mentor to thousands of youth.',
      'A catalyst for change to foster & promote the well-being of communities. International President- United Nations Global Development Organization – USA, Registered with United Nations, Vice Chairman- Sanasumata Maga (Way To Comfort) NGO, International Director of Youth Affairs- Academy Of Universal Global Peace – USA, Registered With United Nations, CEO- Kavinda Enterprises Pvt Ltd, Director General- WCM Media, Regional head Sri Lanka – World Peace & Diplomacy Organization (WPDO).'
    ]
  },
  {
    id: 'lead-4',
    role: 'Vice President',
    name: 'Dr. Emeritaa Wijenayake (Fernando)',
    titleDetails: '',
    image: vpEmeritaaImg,
    bio: [
      'Dr. Emeritaa Wijenayake (Fernando) serves as Vice President of the United Nations Global Development Organization (UNGDO), distinguished by a multidisciplinary career encompassing entrepreneurship, strategic communications, international events, media, business development, and the creative industries.',
      'Her professional journey reflects a commitment to visionary leadership, innovation, international engagement, and meaningful social impact. With a strong aptitude for strategic relationship-building and public representation, Dr. Emeritaa engages with diverse professional and international communities to foster collaboration and create new avenues for opportunity.',
      'In her leadership capacity at UNGDO, Dr. Emeritaa is dedicated to advancing sustainable development, entrepreneurship, education, empowerment, and inclusive growth, with particular emphasis on initiatives that inspire women and youth to become catalysts for positive and lasting change.'
    ]
  }
];

const GUIDING_PRINCIPLES = [
  {
    num: '1',
    title: 'Peace & Human Dignity',
    desc: 'Peace is more than the absence of conflict; it is the presence of understanding, respect, justice, dialogue, and human dignity. UNGDO promotes a culture of peaceful coexistence and mutual respect.'
  },
  {
    num: '2',
    title: 'Human Rights & Social Justice',
    desc: 'The protection and advancement of human dignity are fundamental to sustainable societies. UNGDO supports awareness surrounding fundamental human rights, equality, freedom, and justice.'
  },
  {
    num: '3',
    title: 'Sustainable Development',
    desc: 'We believe progress must be responsible, inclusive, and enduring. UNGDO promotes development that harmonizes social advancement, economic opportunity, environmental stewardship, and future generations.'
  },
  {
    num: '4',
    title: 'Empowerment & Opportunity',
    desc: 'Sustainable transformation begins when people are empowered to participate in shaping their own futures through education, leadership, capacity building, skills development, and entrepreneurship.'
  },
  {
    num: '5',
    title: 'International Cooperation',
    desc: 'The most complex challenges confronting humanity cannot be addressed in isolation. UNGDO encourages constructive cooperation, knowledge exchange, dialogue, and partnerships across borders.'
  }
];

function About({ siteData }) {
  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') setSelectedMember(null);
    };
    if (selectedMember) {
      window.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'auto';
    };
  }, [selectedMember]);

  const leadershipList = (siteData?.leadership && siteData.leadership.length > 0)
    ? siteData.leadership
    : DEFAULT_LEADERSHIP;

  const renderMemberCard = (member) => (
    <div
      key={member.id || member.name}
      className="team-card"
      onClick={() => setSelectedMember(member)}
      role="button"
      tabIndex={0}
      itemScope
      itemType="https://schema.org/Person"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSelectedMember(member);
        }
      }}
    >
      <div className="team-card-image-wrap">
        <img src={member.image} alt={`${member.name} - ${member.role} of UNGDO`} className="team-card-image" itemProp="image" />
      </div>
      <div className="team-card-body">
        <div className="team-card-name-row">
          <h3 className="team-card-name" itemProp="name">{member.name}</h3>
          <button
            type="button"
            className="team-card-arrow-btn"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedMember(member);
            }}
            aria-label={`View bio for ${member.name}`}
            title="View Bio"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
        <p className="team-card-role" itemProp="jobTitle">{member.role}</p>
        {member.titleDetails && (
          <p className="team-card-credentials">{member.titleDetails}</p>
        )}
      </div>
    </div>
  );

  return (
    <div className="page-shell about-subpage">
      {/* Hero Banner */}
      <div className="about-hero">
        <span className="about-hero-pill">About UNGDO</span>
        <h1 className="about-hero-title">UNITED NATIONS GLOBAL DEVELOPMENT ORGANIZATION</h1>
        <p className="about-hero-tagline">Advancing Peace • Upholding Human Dignity • Empowering Communities • Shaping a Sustainable Future</p>
        <p className="about-hero-desc">
          The United Nations Global Development Organization (UNGDO) is a mission-driven organization committed to advancing the principles of peace, human dignity, human rights, sustainable development, social progress, and international cooperation.
        </p>
      </div>

      {/* Navigation Pills */}
      <div className="about-nav-pills">
        <NavLink to="/about" className="about-pill-btn active">Overview & Mission</NavLink>
        <NavLink to="/about/areas-of-focus" className="about-pill-btn">12 Areas of Focus</NavLink>
        <NavLink to="/about/strategic-pillars" className="about-pill-btn">Strategic Pillars & SDGs</NavLink>
        <NavLink to="/about/governance" className="about-pill-btn">Governance & Leadership</NavLink>
      </div>

      {/* Core Overview Text Block */}
      <div className="pillar-section" style={{ marginBottom: '36px' }}>
        <h3 style={{ color: '#0c2f4d', marginTop: 0, fontSize: '1.35rem', fontWeight: 800 }}>Institutional Overview</h3>
        <p style={{ fontSize: '1.02rem', lineHeight: 1.75, color: '#475569' }}>
          UNGDO is founded upon the conviction that meaningful development extends beyond economic advancement. It encompasses the dignity of every individual, the empowerment of communities, the protection of fundamental rights, the advancement of knowledge and education, the preservation of our environment, and the cultivation of peaceful and inclusive societies.
        </p>
        <p style={{ fontSize: '1.02rem', lineHeight: 1.75, color: '#475569' }}>
          Through programmes, initiatives, educational outreach, humanitarian engagement, advocacy, and strategic partnerships, UNGDO seeks to translate shared global aspirations into purposeful action and enduring social value. Our work is guided by a profound belief in the potential of individuals and communities to become architects of their own progress when provided with knowledge, opportunity, encouragement, and meaningful platforms for participation.
        </p>
      </div>

      {/* Mission & Vision Split Cards */}
      <div className="mission-vision-grid">
        <div className="mv-card mission-card">
          <div className="mv-icon-badge">🎯</div>
          <h2 className="mv-card-title">OUR MISSION</h2>
          <p className="mv-card-subtitle">Turning Global Priorities into Purposeful Action</p>
          <p className="mv-card-text">
            The mission of UNGDO is to promote awareness, understanding, and constructive engagement with global development priorities while supporting initiatives that foster human advancement, community resilience, social inclusion, environmental responsibility, and sustainable progress.
          </p>
          <p className="mv-card-text">
            We seek to cultivate a culture of informed participation and responsible citizenship by bringing together individuals, professionals, institutions, community leaders, development stakeholders, and organizations around areas of shared purpose.
          </p>
        </div>

        <div className="mv-card vision-card">
          <div className="mv-icon-badge">🔭</div>
          <h2 className="mv-card-title">OUR VISION</h2>
          <p className="mv-card-subtitle">A More Peaceful, Inclusive, and Sustainable World</p>
          <p className="mv-card-text">
            Our vision is of a world in which every individual is afforded dignity, opportunity, security, equality, and the freedom to fulfil their potential.
          </p>
          <p className="mv-card-text">
            We aspire to see communities that are empowered rather than dependent; institutions that collaborate rather than operate in isolation; and individuals who possess the knowledge, confidence, and opportunity to contribute meaningfully to the societies in which they live.
          </p>
        </div>
      </div>

      {/* Guiding Principles */}
      <div style={{ marginBottom: '48px' }}>
        <div className="about-section-header">
          <span className="about-section-subtitle">Core Pillars</span>
          <h2 className="about-section-title">OUR GUIDING PRINCIPLES</h2>
          <p className="about-section-lead">
            Five fundamental values that underpin all UNGDO development, diplomatic, and educational initiatives.
          </p>
        </div>

        <div className="principles-grid">
          {GUIDING_PRINCIPLES.map((principle) => (
            <div key={principle.num} className="principle-card">
              <div className="principle-header">
                <span className="principle-num">{principle.num}</span>
                <h3 className="principle-title">{principle.title}</h3>
              </div>
              <p className="principle-desc">{principle.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Executive Leadership Spotlight */}
      <section className="un-leadership-section">
        <div className="un-leadership-header">
          <span className="un-pill">Governance & Guidance</span>
          <h2 className="un-section-title">Executive Leadership & Board of Directors</h2>
          <p className="un-section-desc">
            Meet the distinguished diplomats, scholars, philanthropists, and leaders guiding UNGDO worldwide. Click any profile to read full biography.
          </p>
        </div>

        <div className="team-grid">
          {leadershipList.map(renderMemberCard)}
        </div>
      </section>

      {/* Member Bio Modal Popup */}
      {selectedMember && (
        <div
          className="team-modal-backdrop"
          onClick={() => setSelectedMember(null)}
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-member-name"
        >
          <div className="team-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="team-modal-close-btn"
              onClick={() => setSelectedMember(null)}
              aria-label="Close biography modal"
              title="Close"
            >
              ✕
            </button>
            <div className="team-modal-body">
              <div className="team-modal-img-wrap">
                <img src={selectedMember.image} alt={selectedMember.name} className="team-modal-img" />
              </div>
              <div className="team-modal-text-wrap">
                <h2 id="modal-member-name" className="team-modal-name">{selectedMember.name}</h2>
                <p className="team-modal-role">{selectedMember.role}</p>
                {selectedMember.titleDetails && (
                  <p className="team-modal-credentials">{selectedMember.titleDetails}</p>
                )}
                <div className="team-modal-bio">
                  {Array.isArray(selectedMember.bio) ? (
                    selectedMember.bio.map((paragraph, idx) => (
                      <p key={idx}>{paragraph}</p>
                    ))
                  ) : (
                    <p>{selectedMember.bio}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Call to Action Banner */}
      <div className="about-cta-banner">
        <h2 className="about-cta-title">Explore UNGDO Engagement Areas</h2>
        <p className="about-cta-text">
          Discover our 12 Core Areas of Focus, Strategic Pillars, and International Advisory Structure.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <NavLink to="/about/areas-of-focus" className="about-cta-btn">
            View 12 Areas of Focus →
          </NavLink>
          <NavLink to="/about/governance" className="about-cta-btn" style={{ background: '#ffffff', color: '#0c2f4d' }}>
            Governance Structure →
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default About;
